import Component from "./Loader";
export default Component;
